// extracted by mini-css-extract-plugin
module.exports = {"title":"title-CqW_FCCt"};